export default "__VITE_ASSET__BVPx9j1A__"